import PropTypes from "prop-types";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import MaskAndValid from "utils/maskAndValid";
import { sortableField } from "utils/tables-utils";

const getColumnModel = (consultarCNPJ360) => [
  {
    dataField: "consultar",
    text: "",
    isDummyField: true,
    formatter: consultarCNPJ360,
  },
  sortableField({
    dataField: "CnpjCpfPessoa",
    text: "CNPJ",
    formatter: (params) => {
      return MaskAndValid.maskCPNJCPF(params);
    },
  }),
  sortableField({
    dataField: "Nome",
    text: "Razão Social",
  }),
  sortableField({
    dataField: "Apelido",
    text: "Nome Contato",
  }),
  sortableField({
    dataField: "NomeGrupo",
    text: "Nome Grupo",
  }),
  sortableField({
    dataField: "EndPrincipalCidade",
    text: "Cidade",
  }),
  sortableField({
    dataField: "EndPrincipalUf",
    text: "UF",
  }),
];

const TableFiltrosAvancados = ({ data, consultarCNPJ360 }) => {
  return (
    <ToolkitTable
      keyField="IdPessoa"
      columnModel={getColumnModel(consultarCNPJ360)}
      dataTable={data}
      searched={Boolean(data)}
      pagination={{
        options: [25, 50, 100],
        defaultOption: 25,
      }}
      notFoundTitle="Sua pesquisa não encontrou nenhuma lojista correspondente."
    />
  );
};

TableFiltrosAvancados.propTypes = {
  /**
   * Registros que serão exibidos na table
   */
  data: PropTypes.array,
  /**
   * Callback da consulta de CNPJ
   */
  consultarCNPJ360: PropTypes.func,
};

export default TableFiltrosAvancados;
